
var ZVPA_KEY = "XNpMRQ";
var ZVPA_LIST = window.ZVShop.listId;

function zvPaSay(t){ var m = document.getElementById('zvPaMsg'); if (m) m.textContent = t; }

function zvPaPost(path, body){
  return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + ZVPA_KEY, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
    body: JSON.stringify(body)
  }).then(function(r){
    if (r.status === 202 || r.ok) return true;
    throw new Error(path + ' ' + r.status);
  });
}

function zvPaJoin(){
  var email = document.getElementById('zvPaEmail').value.trim();
  var ageEl = document.getElementById('zvPaAge');
  var age = ageEl ? ageEl.value : '';
  var b = document.getElementById('zvPaJoin');
  zvPaSay('');
  if (!email || email.indexOf('@') < 1 || email.indexOf('.') < 0){ zvPaSay('Please enter a valid email address.'); return; }
  b.disabled = true; b.textContent = 'One moment…';

  var props = { signup_source: 'not-tired' };
  if (age) props.age_range = age;

  var subPayload = {
    data: {
      type: 'subscription',
      attributes: { profile: { data: { type: 'profile', attributes: { email: email, properties: props } } } },
      relationships: { list: { data: { type: 'list', id: ZVPA_LIST } } }
    }
  };
  // Both calls are required. /client/subscriptions/ sets consent and list membership but
  // writes NO properties onto a profile that already exists (proven 2026-08-11).
  // /client/profiles/ writes the fields on new and existing profiles alike.
  var profPayload = { data: { type: 'profile', attributes: { email: email, properties: props } } };

  zvPaPost('subscriptions', subPayload)
    .then(function(){ return zvPaPost('profiles', profPayload); })
    .then(function(){
      document.getElementById('zvPaForm').style.display = 'none';
      document.getElementById('zvPaNote').style.display = 'none';
      document.getElementById('zvPaOk').classList.add('show');
      if (window.fbq) { if (window.ZVAM && typeof window.ZVAM.lead === 'function') { window.ZVAM.lead({}, { email: email }); } else { fbq('track','Lead'); } }
    })
    .catch(function(){
      b.disabled = false; b.textContent = 'Join the waitlist';
      zvPaSay('Something went wrong. Please try again.');
    });
}

document.addEventListener('keydown', function(e){
  if (e.key === 'Enter' && document.activeElement && document.activeElement.id === 'zvPaEmail') zvPaJoin();
});

;

// Market-aware price. Do not type a figure into this page again.
(function(){
  var SYMBOL = { USD:'$', GBP:'£', EUR:'€' };
  var FIRST_PAINT = { USD:6900, GBP:4900 };
  var code = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
  function fmt(cents){
    var v = cents / 100;
    return (SYMBOL[code] || code + ' ') + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }
  function paint(cents){
    window.ZV_PRICE = fmt(cents);
    var n = document.querySelectorAll('.zv-price-auto');
    for (var i = 0; i < n.length; i++) n[i].textContent = window.ZV_PRICE;
  }
  if (FIRST_PAINT[code]) paint(FIRST_PAINT[code]);
  fetch('/products/the-pdrn-serum.js', { headers:{ 'Accept':'application/json' } })
    .then(function(r){ return r.ok ? r.json() : null; })
    .then(function(p){ if (p && typeof p.price === 'number') paint(p.price); })
    .catch(function(){});
})();
